import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import ReactionEmojiComp from '../../emojis/reaction-emojis';
import { okrDetailActions } from '../../../actions/okr/okrDetails.actions';
import { useTranslation } from 'react-i18next'
import { isReadOnlyUserLicenseType } from '../../../utils/common';

export default memo(function KrEmojiHover(props) {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const updateReactedEmojis = (data) => dispatch(okrDetailActions.updateKRReactedEmoji(data));
  const emojiParams = () => {
    const obj_id = props.metric.id;
    const obj_type = 'kr';
    const event_target_type = 'KR_ROW';
    return {
      obj_id,
      obj_type,
      obj_owner: props.metric.owner,
      event_type: 'kr_row',
      event_target_type,
      goal_id: props.metric.goal_id || props.goalId,
      parent_metric_id: props.parentMetricId
    };
  }

  return (
    <div className="krEmojiHover">
      <ReactionEmojiComp
        key={'reaction-emoji-comp-kr-row-'}
        wrapperClass='reaction-emoji-kr-row-wrapper'
        params={emojiParams()}
        emojisData={props.emojisData}
        metric={props.metric}
        show_reacted_emoji={props.showReactedEmoji}
        krRowEmojis={props.krRowEmojis}
        showReaction={props.showReaction}
        hide_reaction_emoji={false}
        reacted_emojis={props.metric.reacted_emojis || []}
        updateReactedEmojis={updateReactedEmojis}
        goalId={props.goalId}
        id_of_emoji='okr-emoji-btn'
        changeShowEmojiHoverState={props.changeShowEmojiHoverState}
        emojiFocusId={props.emojiFocusId}
        title = {t("Add a reaction")}
        isReadOnlyEnabled = {isReadOnlyUserLicenseType()}
      />
    </div>
  )
});
